
import React, { memo, useCallback, useMemo, useState } from "react";
import { PasswordContainer } from "../../../../components/PasswordContainer";
import { useLocalization } from "../../../../hooks/localization"
import { ColumnModel, SettingsList } from "../../../../components/Settings/SettingsList";
import { SettingsPageContainer } from "../../../../components/Settings/SettingsPageContainer";
import { BridgeDeviceModel } from "../../../../types/bridge-device";
import { useFilterSelector } from '../../../../hooks/filter-selector';


export const KeypadListScreen = memo(function KeypadListScreen() {
    const { t } = useLocalization();
    const columns = useMemo<ColumnModel[]>(
        () => [{ length: 3, name: t('device_name'), key: "name" }], [t]
    )
    const keyExtractor = (item: BridgeDeviceModel) => item.id;
    const displayNameExtractor = useCallback((item: BridgeDeviceModel, column: ColumnModel) => {
        if (column.key === 'name') { return item.name || '-'; }
    }, [])
    const keypadDeviceList = useFilterSelector(
        (state) => state.control.bridgeDeviceList, (d) => d.type_id === '32'
    );
    const [selectedMenuItem, setSelectedMenuItem] = useState<BridgeDeviceModel>(null);
    const buttons = useMemo(() => [
        {
            text: t('pin_list'),
            url: `/settings/keypad/${selectedMenuItem ? selectedMenuItem.id : ''}/`,
            className: 'blue',
            hidden: !selectedMenuItem,
        }, {
            text: t('settings'),
            url: `/settings/keypad/${selectedMenuItem ? selectedMenuItem.id : ''}/edit/`,
            className: 'blue',
            hidden: !selectedMenuItem
        }
    ], [t, selectedMenuItem]);

    return (
        <PasswordContainer requiredRole="user" isFullscreen={true}>
            <SettingsPageContainer
                buttons={buttons}
                className='keypad-list-page'
                backUrl={"/settings"}
                searchable={true}
            >
                <SettingsList
                    columns={columns}
                    items={keypadDeviceList}
                    listType='keypadDeviceList'
                    selectedItem={selectedMenuItem}
                    onItemSelected={setSelectedMenuItem}
                    displayNameExtractor={displayNameExtractor}
                    keyExtractor={keyExtractor}
                />
            </SettingsPageContainer>
        </PasswordContainer>
    )
})
